define('Components/SponsorshipWidget/js/models/SponsorshipWidgetInstanceModel',[
        'WidgetInstanceModel',
        'app',
        'UrlFactory',
        'formatSmsLink'
    ],
    function (WidgetInstanceModel, app, UrlFactory, formatSmsLink) {
        return WidgetInstanceModel.extend({
            name: 'SponsorshipWidgetModel',
            setup: function () {
            },
            render: function () {
                console.log(this);
            },
            getImage: function () {
                return app.getPictureUrl(this.p('background_image'), 'Widget', 'origin', 'JPG');
            },
            isLogged: function(){
                return app.getCustomer().isLogged();
            },
            isEligible: function () {
                return app.getCustomer().getSponsorship();
            },
            getSponsorshipCode: function () {
                return app.getCustomer().getSponsorship().code;
            },
            getCustomerFirstName: function () {
                return app.getCustomer().getFirstname();
            },
            getHeaderText: function () {
                if (app.getCustomer()) {
                    return this.p('header_text').replace(/{{name}}/g, this.getCustomerFirstName());
                }
                return this.p('header_text');
            },
            getSmsLink: function () {
                return formatSmsLink({
                    phone: null,
                    body: t("%s partage son code %s par SMS", "Sponsorship", [this.getCustomerFirstName(), this.getSponsorshipCode()])
                })
            }
        })
    });
